import { I18n } from '@calendly/i18n';
import { IconAlertCircleFilled } from '@calendly/ui/components/glyphs/IconAlertCircleFilled';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import classNames from 'classnames';
import { forwardRef } from 'react';
const errorContainerCss = "e19o8c66";
const ErrorContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(errorContainerCss, props.className)} />;
});
export const Error = () => <ErrorContainer>
    <UiIcon icon={IconAlertCircleFilled} size="small" spacingTop="4" />
    <p>
      {I18n.t('publisher.meetings.filter_modal.error')}
    </p>
  </ErrorContainer>;

require("./error.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./error.js");